<template>
    <div v-if="allow" class="col-md-12" :class="this.partOfSection === false ? [validatedSectionClass, generalClass] : ''">
      <div class="row">
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group text-center">
          <label
            class="control-label"
            :class="{ required: required }"
          >
            {{computeCaption(caption, this.$store.state.lang.value.toLowerCase())}}
          </label>
          <div class="green-border">
          <br>
          <img src="/static/img/cloud%20icon.png" class="cloud-image">
          <br>
          <h6>
            {{computeCaption(this.fields_en['choose_file_or_take_picture'], this.$store.state.lang.value.toLowerCase())}}
            </h6>
          <small>
            {{computeCaption(this.fields_en['jpg_png_pdf'], this.$store.state.lang.value.toLowerCase())}}
          </small>
          <br><br>
          <div :name="caption" class="upload text-center inline">
            <div style="display: inline-block; white-space: initial;"> 
              <el-upload
              action="#"
              :file-list="fileList"
              :on-change="handleChange"
              list-type="picture-card"
              :auto-upload="false"
              :limit="limit"
              accept=".png, .jpg, .jpeg, .gif, .pdf"
              :disabled="this.fileList.length === this.limit">
              <i class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}">
              <img
              class="el-upload-list__item-thumbnail"
              :src="file.raw.type.indexOf('pdf') > 0 ? 'data:image/png;base64,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' : file.url" alt=""
              >
              <span class="el-upload-list__item-actions">
              <span
              class="el-upload-list__item-delete"
              @click="handleRemove(file)"
              >
              <i class="el-icon-delete"></i>
              </span>
              </span>
              </div>
            </el-upload>
            </div>
            <div v-if="!isMobile() && take_picture_webcam">
              <button id="show-camera" 
                    @click="showCamera()" 
                    v-if="!show && this.fileList.length < this.limit" 
                    class="button">
                    <i class="el-icon-camera"></i>
              </button>
            </div>
          </div>
            <video :id="videoElement" :class="show ? 'video' : 'hideVideo'" autoplay></video>
            <div style="white-space: pre">
              <canvas :id="canvasElement" style="display:none;" :width="$store.state.configs.IMAGE_COMPRESSION_MAX_WIDTH" :height="$store.state.configs.IMAGE_COMPRESSION_MAX_HEIGHT"></canvas>
              <button id="start-camera" 
                    @click="takePicture()" 
                    v-if="show && this.fileList.length < this.limit" class="button">
                    <i class="el-icon-camera"></i>
              </button>
              <button id="stop-camera" 
                    @click="closeCamera()" 
                    v-if="show && this.fileList.length < this.limit" class="button">
                    <i class="el-icon-close"></i>
              </button>
            </div>
          <div v-if="this.caption.toLowerCase().includes('insurance')" class="default-grey font-small" v-show="getFieldDescription('insurance_card_image')" v-html="getFieldDescription('insurance_card_image') || ''">
          </div>
          <div v-if="this.caption.toLowerCase().includes('driver')" class="default-grey font-small" v-show="getFieldDescription('driver_license_image')" v-html="getFieldDescription('driver_license_image') || ''">
          </div>
          <small class="text-danger" v-show="error">
            {{computeCaption(error, this.$store.state.lang.value.toLowerCase())}}
          </small>
          <small class="primary-color" v-show="exceed_error">
            {{computeCaption(exceed_error, this.$store.state.lang.value.toLowerCase())}}
          </small>
          
          <br>
          </div>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import {Upload, Button} from 'element-ui'
import {mapFields} from 'vee-validate'
import {TranslationsUtils} from '../../../../../utils/Translations.js'
import {ValidationUtils} from '../../../../../utils/Validation'
import {PatientInfoUtils} from '../../../../../utils/PatientInfo'
import {AccessionUtils} from '../../../../../utils/AccessionDetailsProcessing'
export default {
  mixins: [TranslationsUtils, ValidationUtils, PatientInfoUtils, AccessionUtils],
  props: {
    allow: {default: undefined},
    required: {default: undefined},
    caption: {default: undefined},
    partOfSection: {default: false}
  },
  components: {
    [Upload.name]: Upload,
    [Button.name]: Button
  },
  data () {
    return {
      videoElement: 'video' + Math.floor((Math.random() * 10000) + 1000),
      canvasElement: 'canvas' + Math.floor((Math.random() * 10000) + 1000),
      allowedFileTypes: [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
        'application/pdf'
      ],
      fields_en: {
        choose_file_or_take_picture: 'Choose file or take picture',
        jpg_png_pdf: 'JPG, PNG or PDF, smaller than 10MB'
      },
      error: '',
      exceed_error: '',
      limit: 6,
      fileList: [],
      generalClass: 'general-inactive-section',
      validatedSectionClass: '',
      model: {
        images: [],
        names: [],
        imagesUids: []
      },
      show: false,
      stream: ''
    }
  },
  computed: {
    ...mapFields(['driver_license_image', 'insurance_card_image']),
    take_picture_webcam () {
      if (this.$store.state.configs.TAKE_PICTURE_WEBCAM) {
        return this.$store.state.configs.TAKE_PICTURE_WEBCAM
      }
      return false
    }
  },
  methods: {
    generateRandomNo () {
      let minm = 1000000000000
      let maxm = 9999999999999
      return Math.floor(Math.random() * (maxm - minm + 1)) + minm
    },
    async showCamera () {
      if (this.fileList.length < this.limit) {
        this.show = true
        let video = document.querySelector('#' + this.videoElement)
        this.stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false })
        video.srcObject = this.stream
      } else {
        this.exceed_error = `You can not upload more than ${this.fileList.length} images on this section`
      }
    },
    async takePicture () {
      if (this.fileList.length < this.limit) {
        let video = document.querySelector('#' + this.videoElement)
        let canvas = document.querySelector('#' + this.canvasElement)
        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)
        let image = canvas.toDataURL('image/png')
        let file = {
          name: 'picture',
          raw: {
            type: 'image/png'
          },
          url: image
        }
        let uid = this.generateRandomNo()
        while (this.model.imagesUids.indexOf(uid) > -1) {
          uid = this.generateRandomNo()
        }
        file.uid = uid
        this.fileList.push(file)
        this.handleChange(file, this.fileList)
        this.closeCamera()
      } else {
        this.exceed_error = `You can not upload more than ${this.fileList.length} images on this section`
      }
    },
    handleRemove (file) {
       // remove file and file.name from model.images and model.names
      let index = this.model.imagesUids.indexOf(file.uid)
      if (index > -1) {
        this.fileList.splice(index, 1)
        this.model.images.splice(index, 1)
        this.model.names.splice(index, 1)
        this.model.imagesUids.splice(index, 1)
      }
      if (this.fileList.length === 0) {
        if (this.required === true) {
          this.error = 'This field is required'
        }
        this.validatedSectionClass = 'invalid-section-class'
        this.generalClass = 'general-invalid-section'
        this.$emit('isValidMultipleInput', false)
      }
      if (this.fileList.length < this.limit) {
        this.exceed_error = ''
      }
    },
    handleChange (file, fileList) {
      if (!this.allowedFileTypes.includes(file.raw.type)) {
        this.exceed_error = 'This type of file is not accepted'
        fileList.pop()
      } else {
        this.exceed_error = ''
        this.createImage(file)
        this.fileList = fileList
        this.error = ''
        this.validatedSectionClass = 'validated-section-class'
        this.generalClass = 'general-inactive-section'
        this.$emit('isValidMultipleInput', true)
        if (fileList.length === this.limit) {
          this.exceed_error = `You can not upload more than ${fileList.length} images on this section`
        }
      }
    },
    closeCamera () {
      this.stream.getTracks().forEach(function (track) {
        track.stop()
      })
      this.show = false
    },
    async createImage (file) {
      let blobUrl = await fetch(file.url).then(r => r.blob())
      var reader = new FileReader()
      var vm = this
      this.patientInfo = await this.getPatientInfo()
      reader.onload = (e) => {
        // Ensure it's an image and it is not .tif/.tiff
        if (file.raw.type.match(/image.*/) && file.raw.type.indexOf('tif') < 0 && (this.patientInfo.browser !== 'chrome' && this.patientInfo.os !== 'iOS')) {
          const MAX_WIDTH = this.$store.state.configs.IMAGE_COMPRESSION_MAX_WIDTH
          const MAX_HEIGHT = this.$store.state.configs.IMAGE_COMPRESSION_MAX_HEIGHT
          const MIME_TYPE = file.raw.type
          const QUALITY = this.$store.state.configs.IMAGE_COMPRESSION_QUALITY
          // Create a helper image object
          const img = new Image()
          img.src = file.url
          img.onload = function () {
            const [newWidth, newHeight] = vm.calculateSize(img, MAX_WIDTH, MAX_HEIGHT)
            // Create a canvas element setting the width and height to match the new dimensions of the image
            const canvas = document.createElement('canvas')
            canvas.width = newWidth
            canvas.height = newHeight
            // Create a 2D context object and draw the image on the canvas
            const ctx = canvas.getContext('2d')
            ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, newWidth, newHeight)
            var dataURL = canvas.toDataURL()
            vm.model.images.push(dataURL)
            vm.model.names.push(file.name)
            vm.model.imagesUids.push(file.uid)
            canvas.toBlob(
              (blob) => {
                blobUrl = blob
              },
              MIME_TYPE,
              QUALITY
            )
          }
        } else {
          vm.model.images.push(e.target.result)
          vm.model.names.push(file.name)
          vm.model.imagesUids.push(file.uid)
        }
      }
      reader.readAsDataURL(blobUrl)
    },
    calculateSize (img, maxWidth, maxHeight) {
      let width = img.width
      let height = img.height
      // calculate the width and height, constraining the proportions
      if (width > height) {
        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width)
          width = maxWidth
        }
      } else {
        if (height > maxHeight) {
          width = Math.round((width * maxHeight) / height)
          height = maxHeight
        }
      }
      return [width, height]
    },
    async validate () {
      if (this.model.images.length > 0) {
        return [this.model.images, this.model.names]
      } else {
        if (this.required === true) {
          this.error = 'This field is required'
          let elem = document.getElementsByName(this.caption)[0]
          let panel = document.getElementsByClassName('main-panel')[0]
          let top = elem.getBoundingClientRect().top
          panel.scrollTop = panel.scrollTop + top - 300
          return false
        } else {
          return true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../assets/sass/paper/variables';

.cloud-image {
  width: 7vw;
  height: 7vh;
}

.green-border {
  border: 1px dashed $primary-color;
  background-color: #FCFCFC;
}

.general-inactive-section:focus-within {
  border-left-color: $primary-color !important;
}

.hideVideo {
  display: none;
}

.video {
  max-width: 95%;
  height: auto;
}

.upload {
  white-space: nowrap;
}

.inline {
  display: inline-block;
}

.button {
  width: 9vh;
  height: 7vh;
  background-color: #fbfdff;
  border: dashed 0.001px #c0ccda;
  border-radius: 6px;
  color: $primary-color;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 25px;
}

.button:hover {
  border: dashed 0.001px $primary-color;
}

#show-camera {
  margin-top: 10px;
}

#start-camera {
  margin-bottom: 10px;
}

@media screen and (max-width: 991px) {
  .cloud-image {
      width: 15%;
      height: 50px;
      object-fit: contain;
      object-position: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/Sections/MultipleInput.vue